<template>

  <div class="gig-filter container">

    <div class="row">
      <div class="col-sm pl-0 pr-0 pr-sm-2">
        <name-filter
           v-model="nameFilterValue"
           :placeholder="namePlaceholder"/>
      </div>
      <!-- <div class="col-sm pl-0 pr-0 pr-sm-2">
        <brand-filter
           v-model="brandFilterValue"
           :filterData="filterData"
           :placeholder="brandPlaceholder"/>
      </div>
      <div class="col-sm p-0">
        <region-filter
           v-model="regionFilterValue"
           :filterData="filterData"
           :placeholder="regionPlaceholder"/>
      </div> -->
    </div>

    <div v-if="loading" class="mt-5 d-flex justify-content-center">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>

    <template v-if="paginatedCompanies">

      <div class="row mt-4">
        <table class="table table-hover">
          <thead>
            <tr>
              <th scope="col">{{ gigNameLabel }}</th>
              <!-- <th scope="col">{{ lastUpdatedLabel }}</th> -->
            </tr>
          </thead>
          <tbody>
            <tr v-for="(gig, idx) in paginatedCompanies" :key="`gig-${idx}`">
              <td>
                <a :href="`${baseUrl}/${gig.parent_company.code}-${gig.parent_company.slug}`">
                {{ gig.parent_company.name }}
                </a>
              </td>
              <!-- <td>{{ formatLastSubmitted(gig.lastsubmitted) }}</td> -->
            </tr>
          </tbody>
        </table>
      </div>

      <paginate
              v-if="this.paginatedCompanies.length"
              :page-count="numberOfPages"
              :click-handler="paginateResults"
              :containerClass="'pagination'"
              :page-class="'page-item'"
              :page-link-class="'page-link'"
              :prev-link-class="'page-link'"
              :next-link-class="'page-link'"
              :prev-text="prevLabel"
              :next-text="nextLabel">
      </paginate>

    </template>

  </div>
</template>

<script>

import axios from 'axios';
import Paginate from 'vuejs-paginate';
import NameFilter from './NameFilter.vue';

export default {
  name: 'GigFilter',
  components: {
    NameFilter,
    Paginate,
  },
  data() {
    return {
      baseUrl: '',
      filterData: null,
      brandFilterValue: null,
      nameFilterValue: null,
      regionFilterValue: null,
      factories: null,
      filteredCompanies: null,
      paginatedCompanies: null,
      currentPage: 1,
      numberOfPages: 0,
      loading: true,
    };
  },
  props: {
    // brandPlaceholder: String,
    namePlaceholder: String,
    // regionPlaceholder: String,
    gigNameLabel: String,
    lastUpdatedLabel: String,
    prevLabel: String,
    nextLabel: String,
    countryCode: String,
    locale: String,
    pageSize: {
      type: Number,
      default: 42,
    },
  },
  mounted() {
    // this fixes relative links when embedded in plone
    const canonicalLink = document.querySelector('link[rel=canonical]');
    if (canonicalLink) {
      this.baseUrl = canonicalLink.href;
    }

    const factoriesUrl = `${process.env.VUE_APP_WSENGINE_URL}platforms`
      + `/?country_code=${this.countryCode}&locale=${this.locale}`
      + '&fields=parent_company';
    axios
      .get(factoriesUrl)
      .then((response) => {
        const factories = response.data;
        this.factories = factories;
        this.applyFilters();
        this.loading = false;
      });

    // const filterUrl = `${process.env.VUE_APP_WSENGINE_URL}rest/platform/filters/`
    //   + `${this.locale}/${this.projectCode}/${this.displayLocale}`;
    // axios
    //   .get(filterUrl)
    //   .then((response) => {
    //     this.filterData = response.data;
    //   });
  },
  methods: {
    formatLastSubmitted(datestring) {
      // string like '20170819163841'
      let formatted = null;
      if (datestring) {
        // note: momentjs with all it's locales is too big and bloats the app
        // formatted = moment(datestring, 'YYYYMMDDHHmmss').locale(this.displayLocale).format('L');
        const y = datestring.substr(0, 4);
        const m = datestring.substr(4, 2);
        const d = datestring.substr(6, 2);
        const date = new Date(y, m, d);
        try {
          formatted = date.toLocaleDateString(this.displayLocale.replace('_', '-'));
        } catch {
          // locale not found..
          formatted = date.toLocaleDateString();
        }
      }
      return formatted;
    },
    paginateResults(pageNum) {
      this.currentPage = pageNum;
      this.applyPaging();
    },
    applyPaging() {
      this.numberOfPages = Math.ceil(this.filteredCompanies.length / this.pageSize);
      this.paginatedCompanies = this.filteredCompanies.slice(
        (this.currentPage - 1) * this.pageSize,
        this.currentPage * this.pageSize,
      );
    },
    applyFilters() {
      this.currentPage = 1; // reset pagination
      let filtered = [...this.factories];
      // if (this.brandFilterValue && this.brandFilterValue.length > 0) {
      //   // filter results on selected brands
      //   const brandFilterIds = this.brandFilterValue.map(val => val.id);

      //   filtered = filtered.filter((element) => {
      //     const brands = Array.isArray(element.brand_API) ? element.brand_API : [];
      //     const brandIds = brands.map(val => val.id);
      //     const intersect = brandFilterIds.filter(value => brandIds.indexOf(value) !== -1);
      //     return intersect.length > 0;
      //   });
      // }
      // if (this.regionFilterValue && this.regionFilterValue.length > 0) {
      //   // filter results on selected regions
      //   const regionFilterIds = this.regionFilterValue.map(val => +val.id);

      //   filtered = filtered.filter(
      //     element => (regionFilterIds.indexOf(element.regihome_API) !== -1),
      //   );
      // }
      if (this.nameFilterValue) {
        filtered = filtered.filter((element) => {
          // eslint-disable-next-line
          if (String.prototype.hasOwnProperty('normalize')) {
            // neat trick to compare string without diacritics
            const decomposedFilterValue = this.nameFilterValue.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
            const decomposedLabel = element.parent_company.name.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
            return decomposedLabel.indexOf(decomposedFilterValue) > -1;
          }
          // hmm probably IE11
          return element.name.toLowerCase().indexOf(this.nameFilterValue.toLowerCase()) > -1;
        });
      }

      this.filteredCompanies = filtered;
      this.applyPaging();
    },
  },
  watch: {
    // brandFilterValue() {
    //   this.applyFilters();
    // },
    nameFilterValue() {
      this.applyFilters();
    },
    // regionFilterValue() {
    //   this.applyFilters();
    // },
  },
};
</script>

<style lang="scss">

$font-size-base: 2rem !default;
@import 'node_modules/bootstrap/scss/bootstrap';

a.page-link {
  user-select: none;
  &:hover {
    cursor: pointer;
  }
}

.gig-filter {
  /* ugly: copied all v-select styles from vue plugin. In future version the scss
   * of  the vue-select plugin this should be fixed
   */

  .v-select {
    position: relative;
    font-family: inherit;
  }
  .v-select,
  .v-select * {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  /* Rtl support - Because we're using a flexbox-based layout, the `dir="rtl"` HTML
     attribute does most of the work for us by rearranging the child elements visually.
   */
  .v-select[dir="rtl"] .vs__actions {
    padding: 0 3px 0 6px;
  }
  .v-select[dir="rtl"] .dropdown-toggle .clear {
    margin-left: 6px;
    margin-right: 0;
  }
  .v-select[dir="rtl"] .selected-tag .close {
    margin-left: 0;
    margin-right: 2px;
  }
  .v-select[dir="rtl"] .dropdown-menu {
    text-align: right;
  }
  /* Open Indicator */
  .v-select .open-indicator {
    display: flex;
    align-items: center;
    cursor: pointer;
    pointer-events: all;
    transition: all 150ms cubic-bezier(1.000, -0.115, 0.975, 0.855);
    transition-timing-function: cubic-bezier(1.000, -0.115, 0.975, 0.855);
    opacity: 1;
    width: 12px; /* To account for extra width from rotating. */
  }
  .v-select .open-indicator:before {
    border-color: rgba(60, 60, 60, .5);
    border-style: solid;
    border-width: 3px 3px 0 0;
    content: '';
    display: inline-block;
    height: 10px;
    width: 10px;
    vertical-align: text-top;
    transform: rotate(133deg);
    transition: all 150ms cubic-bezier(1.000, -0.115, 0.975, 0.855);
    transition-timing-function: cubic-bezier(1.000, -0.115, 0.975, 0.855);
    box-sizing: inherit;
  }
  /* Open Indicator States */
  .v-select.open .open-indicator:before {
    transform: rotate(315deg);
  }
  .v-select.loading .open-indicator {
    opacity: 0;
  }
  /* Dropdown Toggle */
  .v-select .dropdown-toggle {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    display: flex;
    padding: 0 0 4px 0;
    background: none;
    border: 1px solid rgba(60, 60, 60, .26);
    border-radius: 4px;
    white-space: normal;
  }
  .v-select .dropdown-toggle::after {
    display: none;
  }
  .v-select .vs__selected-options {
    display: flex;
    flex-basis: 100%;
    flex-grow: 1;
    flex-wrap: wrap;
    padding: 0 2px;
    position: relative;
  }
  .v-select .vs__actions {
    display: flex;
    align-items: stretch;
    padding: 0 6px 0 3px;
  }
  /* Clear Button */
  .v-select .dropdown-toggle .clear {
    font-size: 23px;
    font-weight: 700;
    line-height: 1;
    color: rgba(60, 60, 60, 0.5);
    padding: 0;
    border: 0;
    background-color: transparent;
    cursor: pointer;
    margin-right: 6px;
  }
  /* Dropdown Toggle States */
  .v-select.searchable .dropdown-toggle {
    cursor: text;
  }
  .v-select.unsearchable .dropdown-toggle {
    cursor: pointer;
  }
  .v-select.open .dropdown-toggle {
    border-bottom-color: transparent;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
  /* Dropdown Menu */
  .v-select .dropdown-menu {
    display:block;
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 1000;
    min-width: 160px;
    padding: 5px 0;
    margin: 0;
    width: 100%;
    overflow-y: auto;
    border: 1px solid rgba(0, 0, 0, .26);
    box-shadow: 0px 3px 6px 0px rgba(0,0,0,.15);
    border-top: none;
    border-radius: 0 0 4px 4px;
    text-align: left;
    list-style: none;
    background: #fff;
  }
  .v-select .no-options {
    text-align: center;
  }
  /* Selected Tags */
  .v-select .selected-tag {
    display: flex;
    align-items: center;
    background-color: #f0f0f0;
    border: 1px solid #ccc;
    border-radius: 4px;
    color: #333;
    line-height: 1.42857143; /* Normalize line height */
    margin: 4px 2px 0px 2px;
    padding: 0 0.25em;
    transition: opacity .25s;
  }
  .v-select.single .selected-tag {
    background-color: transparent;
    border-color: transparent;
  }
  .v-select.single.open .selected-tag {
    position: absolute;
    opacity: .4;
  }
  .v-select.single.searching .selected-tag {
    display: none;
  }
  .v-select .selected-tag .close {
    margin-left: 2px;
    font-size: 1.25em;
    appearance: none;
    padding: 0;
    cursor: pointer;
    background: 0 0;
    border: 0;
    font-weight: 700;
    line-height: 1;
    color: #000;
    text-shadow: 0 1px 0 #fff;
    filter: alpha(opacity=20);
    opacity: .2;
  }
  .v-select.single.searching:not(.open):not(.loading) input[type="search"] {
    opacity: .2;
  }
  /* Search Input */
  .v-select input[type="search"]::-webkit-search-decoration,
  .v-select input[type="search"]::-webkit-search-cancel-button,
  .v-select input[type="search"]::-webkit-search-results-button,
  .v-select input[type="search"]::-webkit-search-results-decoration {
    display: none;
  }
  .v-select input[type="search"]::-ms-clear {
    display: none;
  }
  .v-select input[type="search"],
  .v-select input[type="search"]:focus {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    line-height: 1.42857143;
    font-size: 1em;
    display: inline-block;
    border: 1px solid transparent;
    border-left: none;
    outline: none;
    margin: 4px 0 0 0;
    padding: 0 7px;
    max-width: 100%;
    background: none;
    box-shadow: none;
    flex-grow: 1;
    width: 0;
    height: inherit;
  }
  .v-select.unsearchable input[type="search"] {
    opacity: 1;
  }
  .v-select.unsearchable input[type="search"]:hover {
    cursor: pointer;
  }
  /* List Items */
  .v-select li {
    line-height: 1.42857143; /* Normalize line height */
  }
  .v-select li > a {
    display: block;
    padding: 3px 20px;
    clear: both;
    color: #333; /* Overrides most CSS frameworks */
    white-space: nowrap;
  }
  .v-select li:hover {
    cursor: pointer;
  }
  .v-select .dropdown-menu .active > a {
    color: #333;
    background: rgba(50, 50, 50, .1);
  }
  .v-select .dropdown-menu > .highlight > a {
    /*
     * required to override bootstrap 3's
     * .dropdown-menu > li > a:hover {} styles
     */
    background: #5897fb;
    color: #fff;
  }
  .v-select .highlight:not(:last-child) {
    margin-bottom: 0; /* Fixes Bulma Margin */
  }
  /* Loading Spinner */
  .v-select .spinner {
    align-self: center;
    opacity: 0;
    font-size: 5px;
    text-indent: -9999em;
    overflow: hidden;
    border-top: .9em solid rgba(100, 100, 100, .1);
    border-right: .9em solid rgba(100, 100, 100, .1);
    border-bottom: .9em solid rgba(100, 100, 100, .1);
    border-left: .9em solid rgba(60, 60, 60, .45);
    transform: translateZ(0);
    animation: vSelectSpinner 1.1s infinite linear;
    transition: opacity .1s;
  }
  .v-select .spinner,
  .v-select .spinner:after {
    border-radius: 50%;
    width: 5em;
    height: 5em;
  }
  /* Disabled state */
  .v-select.disabled .dropdown-toggle,
  .v-select.disabled .dropdown-toggle .clear,
  .v-select.disabled .dropdown-toggle input,
  .v-select.disabled .selected-tag .close,
  .v-select.disabled .open-indicator {
    cursor: not-allowed;
    background-color: rgb(248, 248, 248);
  }
  /* Loading Spinner States */
  .v-select.loading .spinner {
    opacity: 1;
  }
  /* KeyFrames */
  @-webkit-keyframes vSelectSpinner {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  @keyframes vSelectSpinner {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  /* Dropdown Default Transition */
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .15s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
}

</style>
